<div class="cont-input-cant flex" style="height: {h};">
      <div
            class="cont-menos flex-center-h flex-center-v"
            on:click={disminuir}
            on:keypress={disminuir}
      >
            -
      </div>
      <div class="cont-cant">
            <input
                  type="text"
                  class="real-input w-100 center flex-center-h"
                  bind:value
                  style="height: {h};"
                  on:change={validar}
                  inputmode="numeric"
            />
      </div>
      <div class="cont-mas flex-center-h flex-center-v" on:click={aumentar} on:keypress={aumentar}>
            +
      </div>
</div>

<script>
      export let value = 0;
      export let h = "25px";
      function aumentar() {
            value = parseInt(value) + 1;
      }
      function disminuir() {
            if (value > 0) {
                  value = parseInt(value) - 1;
            }
      }
      function validar() {
            value = parseInt(value);
            if (value < 0) {
                  value = parseInt(0);
            }
      }
</script>

<style>
      .cont-input-cant {
            border: solid 1px lightgrey;
            border-radius: 18px;
            overflow: hidden;

            width: 90px;
      }
      .cont-cant {
            width: 100%;
      }
      .cont-menos,
      .cont-mas {
            width: 25px;
            /* height: 20px; */
            /* padding: 6px; */
            background-color: #7f56da;
            color: white;
            cursor: pointer;
            /* border-radius: 50px; */
      }
      .real-input {
            width: 50%;
      }
</style>
